import {getSafeHttpsUrl} from '../../utils/safeUrl.ts';

// Aceita somente o selo personalizado oficial; o identificador de exemplo não é válido.
export function getAsaasSealUrl(value?: string): string | null {
  const url = getSafeHttpsUrl(value);
  if (!url) return null;
  const parsed = new URL(url);
  if (parsed.hostname !== 'baas.asaas.com' || !parsed.pathname.startsWith('/selos/')) return null;
  const id = parsed.searchParams.get('id');
  if (!id || /^x+$/i.test(id)) return null;
  return url;
}
